module.exports = __webpack_public_path__ + "img/9788932911472.5f622d55.jpg";